﻿$.fn.dxCtrlEmailPrevisualisation = function custom_dxCtrlEmailPrevisualisation(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemailprevisualisation dx-ctrl");
        this.createInstance(new cdxCtrlEmailPrevisualisation(this, option));
    }
    return this;
}

window.cdxCtrlEmailPrevisualisation = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.inPopup == 'undefined') option.inPopup = true

    function mConstruit() {
        container.empty()
        if (option.inPopup) {
            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                fullScreen: true,
                showTitle: false,
                contentTemplate: function (contentElement) {
                    contentElement.css("position", "relative")
                    mRempli(contentElement)

                    dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:2px'/>").appendTo(contentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton,
                        height: HeightButton,
                        onClick: function (e) {
                            popup.hide()
                        }
                    }).dxCtrlButton("instance");
                }
            }).dxCtrlPopupBase("instance")
            popup.show()
        } else {
            container.css("position", "relative")
            mRempli(container)
        }
    }

    var $DivDetail = null
    var dxVisu = null
    function mRempli(contentElement) {
        //var ds = ["Ordinateur de bureau", "Mobile", "Boite de réception"]
        var ds = ["Ordinateur de bureau", "Mobile"]
        var dxTabs = $("<div/>").appendTo(contentElement).dxTabs({
            dataSource: ds,
            selectedItem: ds[0],
            onSelectionChanged: function (e) {
                switch (ds.indexOf(e.addedItems[0])) {
                    case 0:
                        mRempliDeskTop()
                        break;
                    case 1:
                        mRempliMobile()
                        break;
                    case 2:
                        mRempliTestAcid()
                        break;
                }
            }
        }).dxTabs("instance")

        $DivDetail = $("<div style='height:calc(100% - " + dxTabs.element().innerHeight() + "px);padding:5px;position:relative;'/>").appendTo(contentElement)
        resizeObserver.mAdd(dxTabs.element(), function () { $DivDetail.css("height", "calc(100% - " + dxTabs.element().innerHeight() + "px)") })

        //dxScroll = $("<div/>").appendTo($DivDetail).dxScrollView({}).dxScrollView("instance")
        //dxScroll.content().css("display", "relative")

        mRempliDeskTop()
    }

    function mHideOld() {
        var oldDxVisu = dxVisu
        if (oldDxVisu != null) {
            oldDxVisu.element().fadeOut(300, function () { oldDxVisu.element().remove() })
        }
    }

    function mRempliDeskTop() {
        mHideOld()
        dxVisu = $("<div style='display:none;'/>").appendTo($DivDetail).dxScrollView({}).dxScrollView("instance")
        $("<div style='position:absolute;width:100%;height:100%;'/>").appendTo(dxVisu.content()).dxCtrlIframeResize({
            disabled: false,
            src: option.urlHtml,
            deltaX: 0,
            onContentReady: function (component) {
                component.element().find("iframe").css("min-height", "100%")
                //window.setTimeout(function () { dxVisu.update() },500)
            }
        }).dxCtrlIframeResize("instance")
        dxVisu.element().fadeIn(300)
    }
    function mRempliMobile() {
        mHideOld()
        dxVisu = $("<div style='position:absolute;display:none;width:100%;height:100%;'/>").appendTo($DivDetail).dxCtrlEmailPrevisualisationMobile({
            src: option.urlHtml,
        }).dxCtrlEmailPrevisualisationMobile("instance")
        dxVisu.element().fadeIn(300)
    }
    function mRempliTestAcid() {
        mHideOld()
        dxVisu = $("<div style='width:100%;height:100%;'/>").appendTo($DivDetail).dxCtrlEmailPrevisualisationAcid({
            bddCtrl: option.bddCtrl,
            //data: option.data,
            //onDemandeObjet: option.onDemandeObjet,
            //onDemandeHtml: option.onDemandeHtml,
            onDemandeUrl: option.onDemandeUrl,
            idTestAcid: option.idTestAcid,
            dateTestAcid: option.dateTestAcid,
            dateDocument: option.dateDocument,
            onNewTest: function (idTest) {
                isDirtyTest = true
                option.idTestAcid = idTest
                if (idTest.length > 0) { option.dateTestAcid = new Date() }
                else { option.dateTestAcid = "" }
                option.onNewTest(idTest)
            },
            html: option.getHtml(),
            objet: option.objet,
            onClose: function () {
                popup.hide()
                //mShowBuilder()
                //dxBuilder.mHidePrevisualisation()
                //dxBuilder.mModeConception()
            }
        }).dxCtrlEmailPrevisualisationAcid("instance")
        dxVisu.element().fadeIn(300)
    }

    this.element = function () { return container }

    mConstruit();
}